import { useQuery } from "@tanstack/react-query";
import { listChains } from "../api/chains";
import type { ChainSummary } from "../types/chain";

export function useChains() {
  return useQuery<ChainSummary[]>({
    queryKey: ["chains"],
    queryFn: listChains,
  });
}
